var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrinksWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "drinks",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "m168 104v-24h48v24a127.571 127.571 0 0 0 6.421 40h-30.421v16h36.915a127.483 127.483 0 0 0 12.685 20.8 112.772 112.772 0 0 1 22.092 59.2h-79.692v16h80v16h16v-24a128.791 128.791 0 0 0 -25.6-76.8 111.681 111.681 0 0 1 -13.048-22.4c-1.336-3.052-2.546-6.2-3.6-9.375a111.609 111.609 0 0 1 -5.752-35.425v-80a8 8 0 0 0 -8-8h-64a8 8 0 0 0 -8 8v80a112.187 112.187 0 0 1 -2.263 22.4l15.677 3.2a128.248 128.248 0 0 0 2.586-25.6zm0-72h48v32h-48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "m136 416h56v16h-56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "m184 480h16v16h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "m384 288h-176a8 8 0 0 0 -7.972 8.664l16 192a8 8 0 0 0 7.972 7.336h144a8 8 0 0 0 7.972-7.335l16-192a8 8 0 0 0 -7.972-8.665zm-8.694 16-4 48h-150.612l-4-48zm-14.667 176h-129.278l-9.334-112h147.946z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "m464 144h-128a32.036 32.036 0 0 0 -32 32v74.39c0 7.345.237 14.787.7 22.119l15.967-1.018c-.446-6.994-.672-14.094-.672-21.1v-42.391h80a8.009 8.009 0 0 1 8 8v40a24 24 0 0 0 48 0v-40a8.009 8.009 0 0 1 8-8h16v42.39a333.217 333.217 0 0 1 -11.713 87.51 348.782 348.782 0 0 0 -12.282 91.71v50.39h-64v16h72a8 8 0 0 0 8-8v-58.39a332.787 332.787 0 0 1 11.718-87.51 349.205 349.205 0 0 0 12.282-91.71v-74.39a32.036 32.036 0 0 0 -32-32zm-24 72v40a8 8 0 0 1 -16 0v-40a24.028 24.028 0 0 0 -24-24h-80v-16a16.019 16.019 0 0 1 16-16h128a16.019 16.019 0 0 1 16 16v16h-16a24.028 24.028 0 0 0 -24 24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "m304 392h-48a8 8 0 0 0 -8 8v48a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8v-48a8 8 0 0 0 -8-8zm-8 48h-32v-32h32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "m128 448h-8v-59.683a80.14 80.14 0 0 0 56-76.317v-11.29a156.559 156.559 0 0 0 -1.507-21.618 156.143 156.143 0 0 0 -4.493-21.21 139.093 139.093 0 0 1 -4.174-56.814c.547-4.062 1.261-8.087 2.122-11.963l7.86-35.37a8 8 0 0 0 -7.808-9.735h-60.687l-32-32 34.344-34.343a8 8 0 0 0 -5.657-13.657h-80a8 8 0 0 0 -8 8v80c0 .035.007.068.008.1a8.039 8.039 0 0 0 .071.952c.015.113.035.225.055.337s.031.229.056.343l7.86 35.368c.861 3.877 1.575 7.9 2.118 11.94a141.627 141.627 0 0 1 1.212 18.42 139.808 139.808 0 0 1 -5.38 38.426 156.135 156.135 0 0 0 -6 42.824v11.29a80.14 80.14 0 0 0 56 76.317v59.683h-8a40.045 40.045 0 0 0 -40 40 8 8 0 0 0 8 8h128a8 8 0 0 0 8-8 40.045 40.045 0 0 0 -40-40zm23.059-256h-110.118c-.384-2.149-6.968-32-6.968-32h124.054s-6.583 29.85-6.968 32zm-66.372-48h-41.374l20.687-20.687zm-52.687-64h52.687l-52.687 52.687zm0 232v-11.29a140.1 140.1 0 0 1 5.382-38.431 155.78 155.78 0 0 0 6-42.819c0-3.8-.157-7.631-.438-11.46h106.1a154.856 154.856 0 0 0 5.575 54.28 139.793 139.793 0 0 1 4.029 19.029 140.438 140.438 0 0 1 1.352 19.401v11.29a64 64 0 0 1 -128 0zm56 79.6q3.948.395 8 .4t8-.4v56.4h-16zm-46.629 88.4a24.042 24.042 0 0 1 22.629-16h64a24.042 24.042 0 0 1 22.629 16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "m129.941 337.941a48 48 0 0 0 0-67.882 8 8 0 0 0 -11.314 0l-56.568 56.568a8 8 0 0 0 0 11.314 48 48 0 0 0 67.882 0zm-6.366-50.2a32.02 32.02 0 0 1 -43.837 43.837z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "m64 248h16v16h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "m104 224h16v16h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "m352 232h16v16h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "m416 320h16v16h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "m400 384h16v16h-16z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrinksWhite);
export default __webpack_public_path__ + "static/media/drinks-white.8f0fd5305c21241a206210ca586649bb.svg";
export { ForwardRef as ReactComponent };